export default "__VITE_ASSET__B$Wr9IDI__"